import passwordValidator from './passwordValidator';
export var testLength = function testLength(value) {
  var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 8;
  return value.length >= length;
};
export var testUppercaseValue = function testUppercaseValue(value) {
  var valueArray = value.split('');
  return valueArray.some(function (letter) {
    return /[A-Z]/.test(letter);
  });
};
export var testLowercaseValue = function testLowercaseValue(value) {
  var valueArray = value.split('');
  return valueArray.some(function (letter) {
    return /[a-z]/.test(letter);
  });
};
export var testSymbolOrNumber = function testSymbolOrNumber(value) {
  return /[0-9!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(value);
};
export var testValidChars = function testValidChars(value) {
  return !value.split('').some(function (letter) {
    return letter.charCodeAt(0) > 255;
  });
};
export default passwordValidator;